import { gql } from "../../../../../gql/__generated__/gql";

export const GET_SUGGESTED_BUDGET = gql(`
  query getSuggestedBudget($input: GetSuggestedBudgetInput!) {
    getSuggestedBudget(input: $input)
  }
`);

export const GET_COLLABS_FOR_USER = gql(`
  query getCollabsForUser {
    getCollabsForUser {
      id
      brandId
      creatorEmail
      productIds
      price
      requirements {
        type
        quantity
        details
      }
      status
      actionRequiredBy
      submittedBy
      messageCount
      unreadMessageCount
      createdAt
      updatedAt
      brand {
        id
        name
        logo
        description
        rating
        categories
        productsCount
        completedCollabs
        createdAt
        updatedAt
      }
      creator {
        email
        userType
        validated
        name
        imageUrl
        rating
        monthlyGMV
        categories
        createdAt
        updatedAt
      }
      products {
        id
        brandId
        name
        productUrl
        imageUrl
        description
        price
        categories
        createdAt
        updatedAt
      }
      submittedContent {
        id
        contentUrl
        contentType
        submittedBy
        submittedAt
        status
      }
    }
  }
`);
